import React, { FC, ReactNode } from 'react';

import { ComposeNodeType } from '../../../../../containers/compose/props';
import translate from '../../../../../i18n/translate';

import { getNoItemsTranslationKey } from './helpers';
import * as Styled from './styled';

export type Props = {
  fallback?: ReactNode;
  nodeType?: ComposeNodeType;
};

/**
 * No result for assignment list
 *
 * @param props          Props passed to the component
 * @param props.fallback Fallback content to show when there are no items
 * @param props.nodeType Whether the compose form is being used for messages or templates
 * @returns              The component itself
 */
const SearchNoResult: FC<Props> = ({ nodeType, fallback = null }) => {
  return (
    <Styled.Wrapper>
      <Styled.Title>
        {translate(getNoItemsTranslationKey(nodeType))}
      </Styled.Title>
      {fallback}
    </Styled.Wrapper>
  );
};

export default SearchNoResult;
